/**
 * UFT Navigation Events
 *
 * Self-contained module that listens for navigation clicks
 * and dispatches corresponding UFT EventManager events.
 *
 * Does NOT push to dataLayer directly - that is handled by ga4-data-layer-analytics.js
 */

window.UFT = window.UFT || {};
window.UFT.NavigationEvents = (function () {
	'use strict';

	const DATA_ATTR_EVENT = 'data-ga4-event';
	const DATA_ATTR_EVENT_VALUE = 'navigation';
	const DATA_ATTR_LOCATION = 'data-ga4-nav-location';
	const DATA_ATTR_COMPONENT = 'data-ga4-nav-component';

	class NavigationEvents {
		constructor() {
			this.debug = false;
			this.eventManager = null;
		}

		init() {
			if (!window.UFT?.EventManager) {
				console.error('[UFT Navigation Events] EventManager not available.');
				return;
			}

			this.eventManager = window.UFT.EventManager;
			this.attachClickListeners();
			this.log('Navigation Events initialized');
		}

		attachClickListeners() {
			const trackedElements = document.querySelectorAll(`[${DATA_ATTR_EVENT}='${DATA_ATTR_EVENT_VALUE}']`);
			trackedElements.forEach((element) => {
				element.addEventListener('click', this.handleClick.bind(this));
			});
		}

		handleClick(event) {
			const trackedElement = event.currentTarget;
			const eventData = this.extractEventData(trackedElement);
			if (!eventData) {
				return;
			}

			this.dispatchNavigationEvent(eventData);
		}

		extractEventData(element) {
			const eventType = element.getAttribute(DATA_ATTR_EVENT);
			const location = element.getAttribute(DATA_ATTR_LOCATION);
			const component = element.getAttribute(DATA_ATTR_COMPONENT);

			if (eventType == null || location == null || component == null) {
				this.log('Missing required data attributes', { eventType, location, component });
				return null;
			}

			const clickText = this.determineClickText(element);

			return {
				event: eventType,
				clickText: clickText,
				elementLocation: location,
				cmsComponent: component,
			};
		}

		determineClickText(element) {
			// Priority: aria-label > title > innerText > alt (for images)
			const ariaLabel = element.getAttribute('aria-label');
			if (ariaLabel) {
				return ariaLabel.toLowerCase();
			}

			const title = element.getAttribute('title');
			if (title) {
				return title.toLowerCase();
			}

			const innerText = element.innerText?.trim();
			if (innerText) {
				return innerText.toLowerCase();
			}

			const img = element.querySelector('img');
			if (img && img.alt) {
				return img.alt.toLowerCase();
			}

			return '';
		}

		dispatchNavigationEvent(data) {
			const eventName = this.eventManager.eventStrings.NAV_CLICK;
			this.eventManager.dispatch(eventName, data);
			this.log('Navigation event dispatched', { eventName, data });
		}

		log(message, data = null) {
			if (!this.debug) {
				return;
			}
			if (data) {
				console.log(`[UFT Navigation Events] ${message}`, data);
			} else {
				console.log(`[UFT Navigation Events] ${message}`);
			}
		}
	}

	return new NavigationEvents();
})();

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		window.UFT.NavigationEvents.init();
	});
} else {
	window.UFT.NavigationEvents.init();
}
